import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { SnackbarProvider } from 'notistack';
import theme from './theme';
import {Moduletheme} from './theme/Moduletheme';
import store from './store';
import router from './router';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './pages/Organization/Hospital/INV/pharmecy/contexts/AuthContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider theme={theme}>
    <Provider store={store}>
      <AuthProvider>
        {/* Notistack Provider wraps your app */}
        <SnackbarProvider
          maxSnack={3}
          autoHideDuration={1000}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          hideIconVariant={true}
          preventDuplicate={true}
        >
          <CssBaseline />
          <RouterProvider router={router} />
        </SnackbarProvider>
      </AuthProvider>
    </Provider>
  </ThemeProvider>
);

// Keep ToastContainer in separate portal if needed
const notification = ReactDOM.createRoot(document.getElementById('notification'));
notification.render(
  <ToastContainer
    theme="colored"
    autoClose={1000}
    hideProgressBar
    pauseOnFocusLoss
    pauseOnHover
    draggable
    position="top-right"
    closeOnClick
  />
);